import gql from 'graphql-tag';
 
export const GET_NOTIFICATION = gql`
query{
  me{
    id
    name
    countNotificationsUnRead
    notifications(first:16, page:1){
      data{
        id
        kind
        message
        created_at
        company{id}
        job{id}
        application{id}
      }
    }
  }
}`
